import {
  isProductActiveDeactivationLocked,
  readIsUsedInActivePackage,
} from "app/shared/api/productDtoHelpers";

type LockProduct = {
  id?: number | string;
  active?: boolean;
  isUsedInActivePackage?: boolean;
  entityUpdate?: boolean;
};

export function useActivePackageDeactivationLock(
  product: LockProduct | null | undefined,
  _productTypeId: number,
  _divisionId: number,
  dto?: unknown
) {
  const isUsedInActivePackage =
    readIsUsedInActivePackage(product) ?? readIsUsedInActivePackage(dto);

  const activeDeactivationLocked = isProductActiveDeactivationLocked(
    product
      ? {
          ...product,
          isUsedInActivePackage:
            typeof isUsedInActivePackage === "boolean"
              ? isUsedInActivePackage
              : product.isUsedInActivePackage,
        }
      : null,
    { formDisabled: Boolean(product?.entityUpdate) }
  );

  return { activeDeactivationLocked, isUsedInActivePackage };
}